import { BRAND } from "../lib/brand";

export const Footer = () => {
  const go = (href) => document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  return (
    <footer data-testid="footer" className="bg-navy border-t border-white/10">
      <div className="mx-auto max-w-7xl px-6 md:px-12 py-16 grid md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-5">
            <img src={BRAND.prism} alt="" className="h-10 w-10 object-contain" />
            <span className="text-xl font-display">
              <span className="text-white">Six</span><span className="gold-text">12</span>
              <span className="text-white"> Consulting</span>
            </span>
          </div>
          <p className="text-sm text-slate-400 max-w-xs leading-relaxed">{BRAND.tagline}</p>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-gold mb-5">Navigate</h4>
          <ul className="space-y-3 text-sm text-slate-400">
            {[["Services", "#services"], ["About", "#about"], ["The Mark", "#mark"], ["Contact", "#contact"]].map(([l, h]) => (
              <li key={h}>
                <button onClick={() => go(h)} className="hover:text-gold transition-colors">{l}</button>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-gold mb-5">Connect</h4>
          <ul className="space-y-3 text-sm text-slate-400">
            <li><a href={`mailto:${BRAND.email}`} className="hover:text-gold transition-colors">{BRAND.email}</a></li>
            <li>{BRAND.domain}</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="mx-auto max-w-7xl px-6 md:px-12 py-6 flex flex-col sm:flex-row justify-between gap-3 text-xs text-slate-500">
          <span>© {new Date().getFullYear()} Six12 Consulting. All rights reserved.</span>
          <span className="uppercase tracking-[0.2em]">Strategy · Protection · Partnership · Preparation</span>
        </div>
      </div>
    </footer>
  );
};
